import React from "react";
import { BOND_PRINCIPAL_KIND } from "../../shared/hooks/useBondPrincipalForm";
import { getBondPrincipalFieldConfig } from "../../shared/bondPrincipalFieldConfig";
import BondPrincipalScreen from "../../shared/components/BondPrincipalScreen";
import { useGuardianshipPrincipalDefaults } from "../hooks/useGuardianshipPrincipalDefaults";
import GuardianshipPrincipalExtraBlocks from "./GuardianshipPrincipalExtraBlocks";
import { BOND_PRINCIPAL_SHELL_GUARDIANSHIP } from "../../shared/bondWizardStepPropTypes";

const GuardianForm = ({
  data = { guardians: [] },
  updateData,
  globalData,
  errors,
  isGuest,
}) => {
  const cfg = getBondPrincipalFieldConfig(BOND_PRINCIPAL_KIND.guardianship);
  const principalCount =
    Number(globalData.basicInformation?.[cfg.guardianCountKey] || 1) || 1;

  useGuardianshipPrincipalDefaults({ principalCount, data, updateData });

  return (
    <BondPrincipalScreen
      kind={BOND_PRINCIPAL_KIND.guardianship}
      data={data}
      updateData={updateData}
      globalData={globalData}
      errors={errors}
      isGuest={isGuest}
      renderExtraBlocks={(i, guardian, guardians) => (
        <GuardianshipPrincipalExtraBlocks
          index={i}
          guardian={guardian}
          guardians={guardians}
          data={data}
          updateData={updateData}
          globalData={globalData}
          errors={errors}
        />
      )}
    />
  );
};

GuardianForm.propTypes = BOND_PRINCIPAL_SHELL_GUARDIANSHIP;

export default GuardianForm;
